import { __assign, __awaiter, __generator } from "tslib";
import { APP_DEFINITION_ID, TrackEventName } from '@wix/wixstores-client-core';
import { ONLINE_STORES_SPECS } from '../../constants';
import { removeUndefinedKeys } from '../../../../lib/removeUndefinedKeys';
import { mapToLineItem } from '../../addToCurrentCart/mapToLineItem';
import { calculateAddToCartCartAction, handleAddToCartAction, preloadCartByAction } from '../../addToCart.utils';
import { reportAddToCartBI } from '../../bi.utils';
import { createClient } from '@wix/sdk/client';
import * as cartV2 from '@wix/auto_sdk_ecom_cart-v-2';
import { ChannelType } from '@wix/auto_sdk_ecom_cart-v-2';
import { getSDKAuthAndHost } from '../../../getSDKAuthAndHost';
function trackAddToCartEvent(ecomPlatformPublicAPI, context, _a) {
    var _b, _c, _d;
    var productId = _a.productId, quantity = _a.quantity, variantId = _a.variantId, trackData = _a.trackData;
    return __awaiter(this, void 0, void 0, function () {
        var cart;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, ecomPlatformPublicAPI.cart.getCurrentCart()];
                case 1:
                    cart = _e.sent();
                    context.trackEvent(TrackEventName.ADD_TO_CART, removeUndefinedKeys({
                        cartId: (_b = cart.cartId) !== null && _b !== void 0 ? _b : undefined,
                        currency: (_d = (_c = cart.convertedCurrencyFormat) === null || _c === void 0 ? void 0 : _c.code) !== null && _d !== void 0 ? _d : undefined,
                        id: productId,
                        quantity: quantity,
                        name: trackData === null || trackData === void 0 ? void 0 : trackData.name,
                        sku: trackData === null || trackData === void 0 ? void 0 : trackData.sku,
                        price: trackData === null || trackData === void 0 ? void 0 : trackData.price,
                        type: trackData === null || trackData === void 0 ? void 0 : trackData.type,
                        category: trackData === null || trackData === void 0 ? void 0 : trackData.category,
                        variantId: variantId,
                    }));
                    return [2 /*return*/];
            }
        });
    });
}
var toLineItem = function (productId, quantity, options, preOrderRequested, context) {
    return mapToLineItem({
        productId: productId.toString(),
        quantity: Number(quantity),
        preOrderRequested: preOrderRequested,
        options: options !== null && options !== void 0 ? options : {},
    }, context);
};
export var createCartExports = function (_a) {
    var context = _a.context;
    return ({
        addToCart: function (productId, quantity, options, preOrderRequested, trackData) { return __awaiter(void 0, void 0, void 0, function () {
            var ecomPlatformPublicAPI, hasCartIcon, addToCartAction, lineItem;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, context.wixAPI.site.getPublicAPI(APP_DEFINITION_ID)];
                    case 1:
                        ecomPlatformPublicAPI = _b.sent();
                        return [4 /*yield*/, ecomPlatformPublicAPI.cart.hasCartIcon()];
                    case 2:
                        hasCartIcon = _b.sent();
                        addToCartAction = calculateAddToCartCartAction(options === null || options === void 0 ? void 0 : options.addToCartAction, hasCartIcon);
                        return [4 /*yield*/, toLineItem(productId, quantity, options, preOrderRequested, context)];
                    case 3:
                        lineItem = _b.sent();
                        return [4 /*yield*/, Promise.all([
                                preloadCartByAction(ecomPlatformPublicAPI, addToCartAction),
                                addToCart(ecomPlatformPublicAPI, [lineItem]),
                            ])];
                    case 4:
                        _b.sent();
                        void trackAddToCartEvent(ecomPlatformPublicAPI, context, {
                            productId: "".concat(productId),
                            quantity: Number(quantity),
                            variantId: options === null || options === void 0 ? void 0 : options.variantId,
                            trackData: trackData,
                        });
                        reportAddToCartBI(context, {
                            origin: 'addToCart',
                            productId: "".concat(productId),
                            quantity: Number(quantity),
                            hasOptions: Object.keys((_a = options === null || options === void 0 ? void 0 : options.choices) !== null && _a !== void 0 ? _a : {}).length > 0,
                            trackData: trackData,
                        });
                        return [2 /*return*/, handleAddToCartAction(ecomPlatformPublicAPI, addToCartAction, "".concat(productId))];
                }
            });
        }); },
        createCart: function (productId, quantity, options, preOrderRequested) { return __awaiter(void 0, void 0, void 0, function () {
            var lineItem, wixClient, cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, toLineItem(productId, quantity, options, preOrderRequested, context)];
                    case 1:
                        lineItem = _a.sent();
                        wixClient = createClient(__assign(__assign({}, getSDKAuthAndHost(context.siteStore)), { modules: {
                                cart: {
                                    createCart: cartV2.createCart,
                                },
                            } }));
                        return [4 /*yield*/, wixClient.cart.createCart({
                                catalogItems: [lineItem],
                                cart: { source: { channelType: ChannelType.WEB } },
                            })];
                    case 2:
                        cart = _a.sent();
                        return [2 /*return*/, { id: cart._id }];
                }
            });
        }); },
        addProducts: function (items, _options) { return __awaiter(void 0, void 0, void 0, function () {
            var ecomPlatformPublicAPI, lineItems, shouldAddTrackData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, context.wixAPI.site.getPublicAPI(APP_DEFINITION_ID)];
                    case 1:
                        ecomPlatformPublicAPI = _a.sent();
                        return [4 /*yield*/, Promise.all(items.map(function (item) { return __awaiter(void 0, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
                                return [2 /*return*/, mapToLineItem(__assign(__assign({}, item), { productId: (_a = item.productId) !== null && _a !== void 0 ? _a : item.productID }), context)];
                            }); }); }))];
                    case 2:
                        lineItems = _a.sent();
                        return [4 /*yield*/, addToCart(ecomPlatformPublicAPI, lineItems)];
                    case 3:
                        _a.sent();
                        shouldAddTrackData = context.experiments.enabled(ONLINE_STORES_SPECS.AddTrackDataOnAddProducts);
                        items.forEach(function (item) {
                            var _a, _b, _c;
                            trackAddToCartEvent(ecomPlatformPublicAPI, context, __assign({ productId: item.productId, quantity: item.quantity }, (shouldAddTrackData ? { trackData: item.trackData, variantId: (_a = item.options) === null || _a === void 0 ? void 0 : _a.variantId } : {})));
                            reportAddToCartBI(context, __assign({ origin: 'addProducts', productId: "".concat(item.productId), quantity: Number(item.quantity), hasOptions: Object.keys((_c = (_b = item.options) === null || _b === void 0 ? void 0 : _b.choices) !== null && _c !== void 0 ? _c : {}).length > 0 }, (shouldAddTrackData ? { trackData: item.trackData } : {})));
                        });
                        return [2 /*return*/];
                }
            });
        }); },
    });
};
function addToCart(ecomPlatformPublicAPI, catalogItems) {
    return __awaiter(this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ecomPlatformPublicAPI.__internal.addLineItemsToCurrentCart({
                            catalogItems: catalogItems,
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=exports.cart.js.map